<template>
  <div>
    <div class="container-title">
      {{ $t('sale_notes.resumes.note') }}
    </div>
    <b-card no-body>
      <b-card-body>
        <template v-if="!editMode">
          <p v-show="value" v-html="value"/>
          <div class="d-flex flex-row-reverse">
            <b-button @click="onClickEdit" v-if="$auth.hasPermissionTo('sale_reports.edit')">{{ $t('Edit') }}</b-button>
          </div>
        </template>
        <template v-else>
          <editor
              ref="editor"
              v-if="$parent.$parent.$options.name !== 'BModal'"
              class="form-control mb-2"
              :init="editorInit"
              inline
              plugins="lists link image paste help wordcount"
              toolbar="undo redo | styleselect | fontselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent"
              v-model="model"
          />
          <div class="d-flex flex-row-reverse">
            <b-button @click="onClickSave">{{ $t('Update') }}</b-button>
          </div>
        </template>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'note',
  props: {
    value: {type: String, default: '-'},
  },
  data() {
    return {
      editMode: false,
      editorInit: {
        height: 512,
        image_title: true,
        automatic_uploads: true,
        file_picker_types: 'image',
        file_picker_callback: this.editorFilePickerCallback,
        mobile: {
          inline: true
        }
      },
      model: this.value
    }
  },
  methods: {
    onClickEdit() {
      this.$set(this, 'editMode', !this.editMode)
    },
    onClickSave() {
      this.$emit('input', this.model)
    }
  }
}
</script>

<style scoped>

</style>